var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 299,
    height: 221,
    viewBox: "0 0 299 221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "169.961%",
    x2: "38.532%",
    y1: "-324.054%",
    y2: "125.543%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#44C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B9F9F0",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-40h300v300H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M264.255 111.742C263.59 172.197 214.41 221 153.842 221 92.86 221 43.423 171.527 43.423 110.5c0-5.053.34-10.026.995-14.899H9.933C4.447 95.601 0 91.154 0 85.67c0-5.486 4.447-9.933 9.933-9.933h78.146c5.486 0 9.933-4.447 9.933-9.933a9.936 9.936 0 0 0-6.468-9.311 9.912 9.912 0 0 1-3.464.62H42.19c-5.486 0-9.933-4.447-9.933-9.932 0-5.486 4.447-9.933 9.933-9.933H71.17C91.401 14.401 120.941 0 153.842 0 201.3 0 241.763 29.96 257.38 72.011h31.688c5.486 0 9.933 4.447 9.933 9.933 0 5.485-4.447 9.932-9.933 9.932h-48.371c-5.486 0-9.933 4.447-9.933 9.933s4.447 9.933 9.933 9.933h23.559z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#87D5FA",
    d: "M153 67l-60 44.469V184a5 5 0 0 0 5 5h110a5 5 0 0 0 5-5v-72.531L153 67z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97 81)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#64808C",
    d: "M16.333 16.895v63.078h81.635V15.938"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeLinecap: "square",
    strokeWidth: 2,
    d: "M34.708 31.735h20.417"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeLinecap: "square",
    d: "M34.68 41.026h43.556M34.68 47.026h43.556M34.68 53.026h43.556"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.819,
    cy: 31.735,
    fill: "#EB8181",
    rx: 6.125,
    ry: 6.077
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#64808C",
    d: "M13.857 0l61.576.692c-8.399 3.69-12.085 9.545-11.058 17.566H0C0 8.972 4.62 2.886 13.857 0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    d: "M75.342.556c11.898-1.835 19.44 3.252 22.625 15.26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#64808C",
    d: "M98 16.88C98 7.558 90.383 0 80.986 0 71.59 0 63.141 6.747 64.361 18.862"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#64808C",
    d: "M214 113l-45 42.76L201.661 189H209a5 5 0 0 0 5-5v-71zM93 113l45 42.809L105.267 189H98a5 5 0 0 1-5-5v-71z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeLinecap: "square",
    d: "M104.608 189.018h97.005"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB8181",
    d: "M100.207 188.536l45.58-43.083a9 9 0 0 1 12.331-.032l46.09 43.115h-104z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#64808C",
    transform: "translate(192 150)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M11.282 23.227l5.141 4.465 12.295-12.307"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.04206ace00aceae1e439dfd94bede692.svg";
export { ForwardRef as ReactComponent };